import { Content, Footer, Header, Sidebar } from 'components/Layout';
import React from 'react';

class MainLayout extends React.Component {
  static isSidebarOpen() {
    return document
      .querySelector('.cr-sidebar')
      .classList.contains('cr-sidebar--open');
  }

  // componentWillReceiveProps({ breakpoint }) {
  //   if (breakpoint !== this.props.breakpoint) {
  //     this.checkBreakpoint(breakpoint);
  //   }
  // }

  componentDidUpdate({ breakpoint }) {
    if (breakpoint !== this.props.breakpoint) {
      this.checkBreakpoint(breakpoint);
    }
  }

  componentDidMount() {
    this.checkBreakpoint(this.props.breakpoint);
  }

  // close sidebar when
  handleContentClick = event => {
    // close sidebar if sidebar is open and screen size is less than `md`
    if (
      MainLayout.isSidebarOpen() &&
      (this.props.breakpoint === 'xs' ||
        this.props.breakpoint === 'sm' ||
        this.props.breakpoint === 'md')
    ) {
      this.openSidebar('close');
    }
  };

  checkBreakpoint(breakpoint) {
    switch (breakpoint) {
      case 'xs':
        return this.openSidebar('close');
      case 'sm': 
        return this.openSidebar('close');
      case 'md':
        return this.openSidebar('open');
      case 'lg':
        return this.openSidebar('open');
      case 'xl':
        return this.openSidebar('open');
      default:
        return this.openSidebar('open');
    }
  }

  openSidebar(openOrClose) {
    if (openOrClose === 'open') {
      return document
        .querySelector('.cr-sidebar')
        .classList.add('cr-sidebar--open');
    }
    document.querySelector('.cr-sidebar').classList.remove('cr-sidebar--open');
  }

  render() {
    const { children } = this.props;
    return(
      <main className="cr-app bg-light">
        <Sidebar />
        <Content fluid>
          <Header />
          {children}
          <Footer />
        </Content>
      </main>      
      ) 
  }
}

export default MainLayout;
